import React from 'react';
import { Link } from 'react-router-dom';

const ClubCard = ({ club }) => {
    const { name, img, objective } = club
    return (
        <div className="card w-96 shadow-xl">
            <figure><img className='h-60' src={img} alt="Shoes" /></figure>
            <div className="card-body">
                <h2 className="card-title">{name}</h2>
                <p className='text-justify'>
                    {
                        objective.length > 350?
                        <p>{objective.slice(0,350)+"..."}</p>:
                        <p>{objective}</p>
                    }
                </p>

            </div>
        </div>
    );
};

export default ClubCard;